module.exports = __webpack_public_path__ + "img/HidlaAddvorgg.73c89ef8.png";